// extracted by mini-css-extract-plugin
export default {"secondaryButton":"secondaryButton__HAdxB","button":"button__m+Rdz"};